import React, { useRef, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import useEffectOnce from '../hooks/useEffectOnce';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { RootState } from '../reducers';
import { fetchdata } from './../reduxactions/organizationactions/OrgApplicationsActions';
import { useNavigate } from 'react-router-dom';
import { GFNButton } from '../ui';
import { Panel } from 'primereact/panel';

const OrganizationApplications = () => {
    const uid = window.sessionStorage.getItem('uid');
    const [globalFilter, setGlobalFilter] = useState('')

    const dispatch = useDispatch();

    useEffectOnce(() => {
        const fetchDataAsync = async () => {
            try {
                await dispatch(fetchdata(uid) as any);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchDataAsync();
    }, [dispatch]);

    const navigate = useNavigate();
    //To open view
    const handleButtonClick = (rowData: any) => {
        const url = `/vieworgapp/${rowData.application_id}`;
        console.log('Row ID:', rowData.application_id);

        // Use navigate to navigate to the URL
        navigate(url);
    };

    const data = useSelector((state: RootState) => state.orgapps.data);
    //for help
    const [openHelp, setHelp] = useState(false);
    const url1 = window.sessionStorage.getItem("apiRoot");
    const IUrl = `${url1}/help/org-applications.php`;
    const helpImg = `${url1}/help/help3.png`;
    const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
        event.preventDefault();
        const newWindowReference = window.open(
            targetUrl,
            'newwindow',
            'width=1000,height=1000,noopener,noreferrer'
        );

        if (newWindowReference) {
            newWindowReference.opener = null;
        }
    };
    return (
        <div className="admin-layout-container">
            <div className="row">
                <div className="main-content">
                    <div className="content-wrapper">
                        <section className="app-page-header">
                            <div>
                                <h1 className="app-page-title">Application</h1>
                            </div>
                            <a title="help" onClick={(e) => openWindow(e, IUrl)} className="app-help-link">
                                Help for this Page
                                <i className="pi pi-question-circle"></i>
                            </a>
                        </section>
                        <Panel>
                            <div className="grid">
                                <div className="col-12">
                                    <div className="card card-primary">
                                        <div className="card flex flex-wrap justify-content-end">
                                            {/* <Button
                                                label="New Application"
                                                severity="info"
                                                data-testid="apply-application-btn"
                                                onClick={() => navigate('/searchfundmanager')}
                                            /> */}
                                            <GFNButton label="New Application" buttonType="primary" data-testid="apply-application-btn" onClick={() => navigate('/searchfundmanager')} />
                                        </div>
                                        <div className="card flex flex-wrap justify-content-end my-2">
                                            <span className="p-input-icon-left">
                                                <i className="pi pi-search ml-2" />

                                                <InputText
                                                    className="app-search-input"
                                                    value={globalFilter}
                                                    onChange={(e) => setGlobalFilter(e.target.value)}
                                                    placeholder="Global Search"
                                                />
                                            </span>
                                        </div>
                                        <DataTable value={data} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} >
                                            <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                                            <Column field="applied_date" sortable header="Applied Date"></Column>
                                            <Column field="name" sortable header="FundManager Name"></Column>
                                            <Column field="orgname" sortable header="Organization "></Column>
                                            <Column field="countryname" sortable header="Country "></Column>
                                            <Column field="status" sortable header="Status "></Column>

                                            <Column header="Operation" body={(rowData, { rowIndex }) => (
                                                <>
                                                    {/* <Button icon="pi pi-eye" data-testid={`view-btn-${rowIndex}`} tooltip="View" rounded outlined className='mr-1' onClick={() => handleButtonClick(rowData)} style={{ color: 'blue' }}></Button> */}
                                                    <GFNButton icon="pi pi-eye" data-testid={`view-btn-${rowIndex}`} tooltip="View" rounded outlined className='mr-1' onClick={() => handleButtonClick(rowData)} buttonType='primary'/>
                                                </>
                                            )} />
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </Panel>
                    </div>
                </div>
            </div>
        </div>
    )

}
export default OrganizationApplications


